/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SortOrderLocation {
    BEGINNING = 'BEGINNING',
    END = 'END',
}
